export const valueApp = 70.00;
export const paymentMethodsList = [
  { id: "3", name: "Efectivo" },
  { id: "1", name: "Transferencia" },
  { id: "4", name: "Zelle" },
  { id: "2", name: "Totalcoin (Aliados comerciales)" },
]